module.exports = __webpack_public_path__ + "img/cju_detail.c4a9de57.jpg";